import React, { useState } from "react";
import AdminTable from "./adminPerformanceChart/AdminTable";
import AdminOverallPie from "./adminPerformanceChart/AdminOverallPie";
import AdminTableFilter from "./AdminTableFilter";
import BarChart from "./AdminBarChart/AdminPerformanceBarChart";
import AdmminLineChart from "./adminLineChart/AdminLineChart";
import styles from "../PieChart.module.scss";
import AdminLineChartFilter from "./adminLineChart/AdminLineChartFilter";
import AdminInterviewChart from "./adminInterviews/AdminInterviewChart";
import AdminInterviewChartFilter from "./adminInterviews/AdminInterviewChartFilter";

function AdminPage() {
  const [chartType, setChartType] = useState("Pie");

  const handleChartChange = (event) => {
    setChartType(event.target.value);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h4>Admin</h4>
        </div>
        <div>
          <div className="d-flex">
            <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="pieChartYes"
                value="Pie"
                checked={chartType === "Pie"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="pieChartYes" className={styles.label}>
                Pie Chart
              </label>
            </div>
            <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="lineChartNo"
                value="Line"
                checked={chartType === "Line"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="lineChartNo" className={styles.label}>
                Line Chart
              </label>
            </div>
            <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="InterviewChartNo"
                value="Interview"
                checked={chartType === "Interview"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="InterviewChartNo" className={styles.label}>
                Interview
              </label>
            </div>
          </div>
        </div>
        {chartType === "Pie" && (
          <div>
            <AdminTableFilter />
          </div>
        )}
        {chartType === "Line" && (
          <div>
            <AdminLineChartFilter />
          </div>
        )}
        {chartType === "Interview" && (
          <div>
            <AdminInterviewChartFilter />
          </div>
        )}
      </div>
      <div style={{ height: "65vh", overflowY: "auto", overflowX: "hidden" }}>
        {chartType === "Pie" && (
          <div className="row">
            <div className="col-sm-6">
              <AdminTable />
            </div>
            <div className="col-sm-6">
              <AdminOverallPie />
            </div>
          </div>
        )}
        {chartType === "Line" && (
          <div className="row">
            <div className="col-sm-12">
              <div className="container">
                <AdmminLineChart />
              </div>
            </div>
          </div>
        )}
        {chartType === "Interview" && (
          <div className="row">
            <div className="col-sm-12">
              <div className="container">
                <AdminInterviewChart />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPage;
